/**
 * Lista amplia de los principales idiomas del mundo
 * Ordenados alfabéticamente en español
 */
export const LANGUAGES = [
    'Alemán',
    'Árabe',
    'Bengalí',
    'Catalán',
    'Chino (Mandarín)',
    'Chino (Cantonés)',
    'Coreano',
    'Danés',
    'Español',
    'Finlandés',
    'Francés',
    'Griego',
    'Hebreo',
    'Hindi',
    'Holandés',
    'Húngaro',
    'Indonesio',
    'Inglés',
    'Italiano',
    'Japonés',
    'Malayo',
    'Noruego',
    'Polaco',
    'Portugués',
    'Portugués (Brasil)',
    'Rumano',
    'Ruso',
    'Sueco',
    'Tailandés',
    'Turco',
    'Ucraniano',
    'Vietnamita',
];

/**
 * Convierte un string de idiomas separados por comas en un array
 * @param {string} languagesString - String con idiomas separados por comas
 * @returns {Array<string>} Array de idiomas
 */
export function parseLanguagesString(languagesString) {
    if (!languagesString) return [];
    return languagesString.split(',').map(lang => lang.trim()).filter(lang => lang);
}

/**
 * Convierte un array de idiomas en un string separado por comas
 * @param {Array<string>} languagesArray - Array de idiomas
 * @returns {string} String con idiomas separados por comas
 */
export function formatLanguagesString(languagesArray) {
    if (!languagesArray || languagesArray.length === 0) return '';
    return languagesArray.join(', ');
}

